import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./shared/components/ErrorBoundary";
import { installGoogleTranslateGuard } from "./googleTranslateGuard";
import { initPerfProbe } from "./utils/perfProbe";

// Make removeChild/insertBefore resilient to Google Translate / Chrome page
// translation re-parenting DOM nodes, which otherwise crashes React with
// NotFoundError (CHAT-MARITACA-27 / CHAT-MARITACA-28). Must run before render.
installGoogleTranslateGuard();

// Perf probe: OFF unless REACT_APP_PERF_PROBE=true / ?perfProbe=1 / localStorage.
// Runs before render so window.__perfProbe__ exists for the measurement harness.
initPerfProbe();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
